import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import MPHButton from "src/components/actionPerformers/MPHButtons/MPHButton";
import MPHFooterPrimary from "src/components/actionPerformers/MPHFooterPrimary/MPHFooterPrimary";
import MPHFooterSecondary from "src/components/actionPerformers/MPHFooterSecondary/MPHFooterSecondary";
import MPHHeaderMain from "src/components/actionPerformers/MPHHeaderMain/MPHHeaderMain";
import MPHInput from "src/components/DataProviders/MPHInput";
import { useApiAxiosRequests } from '../../utils/ApiService/MPHApis';
import { BRAND_NAME, DEVICE_ID, INTERNAL_REDIRECTION_URLS } from "src/config/constants";
import "./PromotionScreen.scss";
import nascarSweepstakesImage from "src/assets/images/nascar_sweepstakes.jpg";

const PromotionScreen = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [isEmailValid, setIsEmailValid] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const acquisitionChannel = searchParams.get("acquisition_channel") || searchParams.get("acquistion_channel") || "web";
  const reward = searchParams.get("reward") || "";
  const isRewardFlow = Boolean(reward);

  const renderNascarHeadingAndCopy = () => (
    <>
      <h4 style={{ textAlign: "left", marginTop: "20px" }}>
        MyPlace Nascar Sweepstakes
      </h4>
      <div className="promotion-screen-content">
        <p className="promotion-screen-description">
          Register for your chance at winning NASCAR Race Tickets by entering your email address below.
        </p>
        <div className="promotion-reward-highlight">
          <p>🏆 Get in the fast lane to win!</p>
          <p>✓ Win NASCAR Race tickets!</p>
          <p>✓ Join or Opt In to Stay Rewarded Program</p>
          <p>🗓️ No Purchase Necessary</p>
          <p>Enter: December 5, 2025 - January 31, 2026</p>
          <p>Winner Drawn: January 31, 2026</p>
        </div>
      </div>
    </>
  );

  const renderSubmitButton = () => (
    <div className={`button-center ${isRewardFlow ? "" : "sweepstakes-button-center"}`}>
      <MPHButton
        disabled={isLoading || !isEmailValid}
        isLoading={isLoading}
        buttonText={isRewardFlow ? "Login To Redeem" : "Submit"}
        onbuttonClick={() => verifyEmail()}
      />
    </div>
  );

  const renderTermsLink = (customStyle?: React.CSSProperties) => (
    <span
      className={`tc ${isRewardFlow ? "" : "sweepstakes-tc"}`}
      style={customStyle}
      onClick={() => {
        navigateToPage(INTERNAL_REDIRECTION_URLS.MPH_STAYREWARED_TERMS);
      }}
    >
      Terms and conditions apply
    </span>
  );

  const {
    tokenGenerate,
    getCustomerByEmail
  } = useApiAxiosRequests();

  const navigateToPage = (redirect?: any) => {
    window.open(redirect, "_blank");
  };

  const tokenGenerateFunc = async () => {
    const payload = {
      identifierType: "EMAIL",
      identifierValue: email.toLowerCase(),
      deviceId: DEVICE_ID,
      brand: BRAND_NAME,
      password: "123",
      confirmPassword: "123",
    };
    setIsLoading(true);
    const res: any = await tokenGenerate(payload);
    setIsLoading(false);
    if (res.data && res.data.status && res.data.status.success) {
      // token and sessionId available in response if needed in future
    }
    return {
      status: res.data && res.data.status && res.data.status.success,
      data: res.data,
    };
  };

  const getCustomerByEMailFunc = async (email: any, token: any) => {
    const data = await getCustomerByEmail({ email: email }, token);
    return data;
  };

  const verifyEmail = async () => {
    const tokenData = await tokenGenerateFunc();

    const data: any = await getCustomerByEMailFunc(
      email.toLowerCase(),
      tokenData?.data?.auth?.token
    );

    if (isRewardFlow) {
      const rewardQueryParam = `&reward=${encodeURIComponent(reward)}`;
      if (data && data.data.status.success === "true") {
        navigate(`/login?promotion=true&rewardredeem=true&email=${email}&acquisition_channel=${acquisitionChannel}${rewardQueryParam}`);
      } else {
        navigate(`/signup?promotion=true&rewardredeem=true&email=${email}&acquisition_channel=${acquisitionChannel}${rewardQueryParam}`);
      }
    } else {
      if (data && data.data.status.success === "true") {
        navigate(`/login?promotion=true&email=${email}&acquisition_channel=${acquisitionChannel}`);
      } else {
        navigate(`/signup?promotion=true&email=${email}&acquisition_channel=${acquisitionChannel}`);
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Take Me to Tulum Sweepstakes | My Place Hotels</title>
        <meta name="description" content="Enter for your chance to win a 4-Night Luxury Getaway to La Zebra Tulum with My Place Hotels Stay Rewarded." />
      </Helmet>
      <MPHHeaderMain active="/my-place-memories-promotion-enrollment" />
      <div className="margin-top">
        {!isRewardFlow ? (
          <div className="promotion-screen sweepstakes-promotion-screen">
            <div className="ptp-hero">
              <p className="ptp-tagline">My Place Hotels · Stay Rewarded</p>
              <h1 className="ptp-title">Take Me to Tulum</h1>
              <p className="ptp-subtitle">Sweepstakes</p>
            </div>

            <div className="ptp-form-card">
              <p className="ptp-description">
                Register for your chance to win a 4-Night Luxury Getaway to{" "}
                <span className="ptp-nowrap">La Zebra Tulum</span> by entering
                your email address below.
              </p>
              <p className="ptp-dates">
                Sweepstakes Dates are October 1 through December 14, 2026
              </p>
              <MPHInput
                placeholder="Enter your email"
                keyboardType={"email"}
                value={email}
                onChangeText={(text: any) => {
                  setEmail(text);
                  setIsEmailValid(emailRegex.test(text));
                }}
              />
              {renderSubmitButton()}
              {renderTermsLink()}
            </div>
          </div>
        ) : (
          <div className="promotion-screen promotion-screen--reward">
            <>
              <div className="promotion-reward-layout">
                <div className="promotion-reward-left">
                  {renderNascarHeadingAndCopy()}
                </div>
                <div className="promotion-reward-right">
                  <img src={nascarSweepstakesImage} alt="MyPlace NASCAR Sweepstakes" />
                </div>
              </div>
              <div className="promotion-reward-controls">
                <div className="promotion-reward-input">
                  <MPHInput
                    placeholder="Enter Email"
                    keyboardType={"email"}
                    value={email}
                    onChangeText={(text: any) => {
                      setEmail(text);
                      setIsEmailValid(emailRegex.test(text));
                    }}
                  />
                </div>
                {renderSubmitButton()}
              </div>
              {renderTermsLink({ marginTop: "20px" })}
            </>
          </div>
        )}
        <MPHFooterPrimary />
        <MPHFooterSecondary />
      </div>
    </>
  );
};

export default PromotionScreen;
